import { render, staticRenderFns } from "./SchoolListPeople.vue?vue&type=template&id=f7659b54&"
import script from "./SchoolListPeople.vue?vue&type=script&lang=js&"
export * from "./SchoolListPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports